import { Component, Output, EventEmitter } from '@angular/core';

import { BaseComponent } from 'src/app/@shared/components/abstract/base.component';
import { CreateClientDialogComponent } from 'src/app/client/components/clients/create-client-dialog/create-client-dialog.component';

@Component({
    selector: 'app-add-organization-card',
    imports: [],
    templateUrl: './add-organization-card.component.html',
    styleUrls: ['./add-organization-card.component.scss']
})
export class AddOrganizationCardComponent extends BaseComponent {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    @Output() addOrganizationClicked = new EventEmitter<void>();

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public onClickCard(): void {
        this.openDialog(CreateClientDialogComponent, 'CREATE_CLIENT_DIALOG');
    }

}
